// import Vue from 'vue';
import { on } from '../utils/dom';

// const isServer = Vue.prototype.$isServer; // 是否服务端渲染
const nodeList = []; // 绑定了v-clickoutside指令的节点
const ctx = '@@clickoutside'; // 定义节点上的clickoutside事件相关的命名空间

let startClick;
let seed = 0;

on(document, 'mousedown', (e) => { startClick = e; }); // 非服务端，绑定鼠标按下事件，事件对象赋值到startClick
on(document, 'mouseup', (e) => {
	// 绑定数据释放事件，触发对应节点上的回调函数
	nodeList.forEach((node) => node[ctx].documentHandler(e, startClick));
});

/**
 * 返回（判断是否点击外部元素，是则调用回调函数）的函数
 * @param el
 * @param binding
 * @param vnode
 * @return {Function}
 */
function createDocumentHandler(el, binding, vnode) {
	return function (mouseup = {}, mousedown = {}) {
		// console.log(vnode.context.popperElm);
		if (!vnode
			|| !vnode.context
			|| !mouseup.target
			|| !mousedown.target
			|| el.contains(mouseup.target)
			|| el.contains(mousedown.target)
			|| el === mouseup.target
			|| (vnode.context.popperElm
				&& (vnode.context.popperElm.contains(mouseup.target)
					|| vnode.context.popperElm.contains(mousedown.target)))) return;

		if (binding.expression
			&& el[ctx].methodName
			&& vnode.context[el[ctx].methodName]) {
			// 调用组件内方法
			vnode.context[el[ctx].methodName]();
		} else {
			// 调用指令值指定的方法
			// eslint-disable-next-line no-unused-expressions
			el[ctx].bindingFn && el[ctx].bindingFn();
		}
	};
}

/**
 * v-clickoutside，v-clickother
 * @desc 点击外部元素才会触发事件
 * @example
 * ```vue
 * <div v-clickoutside="handleClose">
 * ```
 */
export default {
	/**
	 * 只调用一次，指令第一次绑定到元素时调用。在这里可以进行一次性的初始化设置。
	 * @param el 指令所绑定的元素，可以用来直接操作 DOM。
	 * @param binding 一个对象，包含指令绑定的相关信息
	 * @param vnode Vue 编译生成的虚拟节点。移步 VNode API 来了解更多详情
	 */
	bind(el, binding, vnode) {
		nodeList.push(el);
		const id = seed++;
		el[ctx] = {
			id,
			documentHandler: createDocumentHandler(el, binding, vnode),
			methodName: binding.expression,
			bindingFn: binding.value,
		};
	},

	/**
	 * 所在组件的 VNode 更新时调用，但是可能发生在其子 VNode 更新之前。
	 * 指令的值可能发生了改变，也可能没有。
	 * 但是你可以通过比较更新前后的值来忽略不必要的模板更新 (详细的钩子函数参数见下)。
	 * @param el
	 * @param binding
	 * @param vnode
	 */
	update(el, binding, vnode) {
		el[ctx].documentHandler = createDocumentHandler(el, binding, vnode);
		el[ctx].methodName = binding.expression;
		el[ctx].bindFn = binding.value;
	},

	/**
	 * 只调用一次，指令与元素解绑时调用.
	 * 在该指令中清除相关数据引用
	 * @param el
	 */
	unbind(el) {
		const len = nodeList.length;
		for (let i = 0; i < len; i++) {
			if (nodeList[i][ctx].id === el[ctx].id) {
				nodeList.splice(i, 1);
				break;
			}
		}
		delete el[ctx];
	},
};
